import restClient from 'config/httpClient';
import { call, put, retry, takeEvery, takeLatest } from 'redux-saga/effects';

import { downloadBase64, downloadFile } from 'utils/download';
import { createNotification } from 'modules/notifications/actions';

import * as generalActions from '../actions/general';
import * as actionTypes from '../actionTypes';

const RETRY_NUMBER_TIMES = 10;
const RETRY_MEDIA_DELAY = 2000;

export function* getPdfOffer({ payload }) {
  const { request, filename } = payload;

  try {
    const { data: file } = yield call(restClient.request, request);
    yield put(generalActions.getPdfOfferSuccess(file));
    yield call(downloadBase64, file, 'application/pdf', filename);
  } catch (error) {
    yield put(generalActions.getPdfOfferFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'web.error.file.common',
          defaultMessage: 'An error has occurred.',
        },
      })
    );
  }
}

export function* downloadMedias({ payload }) {
  const { request } = payload;
  try {
    const { data: url } = yield call(restClient.request, request);
    yield put(generalActions.downloadMediasSuccess());
    yield put(generalActions.getZipMedias(url));
  } catch (error) {
    yield put(generalActions.downloadMediasFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'web.error.file.common',
          defaultMessage: 'An error has occurred.',
        },
      })
    );
  }
}

export function* fetchGeneratedZip({ payload }) {
  const { request } = payload;
  const response = yield call(restClient.request, request);
  if (response.status !== 200) {
    throw new Error('Wrong status!');
  }
  return response.data;
}

export function* getZipMedias(action) {
  try {
    const zipPath = yield retry(RETRY_NUMBER_TIMES, RETRY_MEDIA_DELAY, fetchGeneratedZip, action);
    yield put(generalActions.getZipMediasSuccess(zipPath));
  } catch (error) {
    yield put(generalActions.getZipMediasFailure(error));
  }
}

export function* downloadZipMedias({ payload: path }) {
  yield call(downloadFile, path);
}

export default function* mediaSagas() {
  yield takeLatest(actionTypes.FETCH_PDF_OFFER, getPdfOffer);
  yield takeLatest(actionTypes.DOWNLOAD_MEDIAS, downloadMedias);
  yield takeEvery(actionTypes.GET_ZIP_MEDIAS, getZipMedias);
  yield takeEvery(actionTypes.GET_ZIP_MEDIAS_SUCCESS, downloadZipMedias);
}
